module.exports = __webpack_public_path__ + "media/showadz-presentation.7971d435.mp4";